
import { useState } from "react";

export const useUIState = () => {
  const [isToolbarVisible, setIsToolbarVisible] = useState(true);
  const [showSampleImages, setShowSampleImages] = useState(false);
  const [showLayersSidebar, setShowLayersSidebar] = useState(false);
  const [showDrawingHistory, setShowDrawingHistory] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [refreshDrawingsCounter, setRefreshDrawingsCounter] = useState(0);

  // This is a function that increments a counter to trigger refreshes
  const refreshDrawings = () => {
    setRefreshDrawingsCounter(prev => prev + 1);
  };

  return {
    isToolbarVisible,
    setIsToolbarVisible,
    showSampleImages,
    setShowSampleImages,
    showLayersSidebar,
    setShowLayersSidebar,
    showDrawingHistory,
    setShowDrawingHistory,
    showPricing,
    setShowPricing,
    refreshDrawings,
    refreshDrawingsCounter,
  };
};
